import { render, staticRenderFns } from "./FacturaEmitirModal.vue?vue&type=template&id=0bb08c4a&scoped=true&"
import script from "./FacturaEmitirModal.vue?vue&type=script&lang=js&"
export * from "./FacturaEmitirModal.vue?vue&type=script&lang=js&"
import style0 from "./FacturaEmitirModal.vue?vue&type=style&index=0&id=0bb08c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb08c4a",
  null
  
)

export default component.exports